import { t } from 'i18next'

import CampaignListFilters from '~/modules/retailMedia/components/_tables/CampaignFilters'
import CampaignTable from '~/modules/retailMedia/components/_tables/CampaignTable'
import CampaignsPageHeader from '~/modules/retailMedia/components/CampaignsPageHeader'
import DashboardRetailMediaCampaigns from '~/modules/retailMedia/components/DashboardRetailMediaCampaigns'
import { ImpressionShareNewsAlert } from '~/modules/retailMedia/components/ImpressionShareNewsAlert'
import MainTabs from '~/modules/retailMedia/components/MainTabs'
import RoasCalculationAlerts from '~/modules/retailMedia/components/RoasCalculationAlerts'

const RetailMediaCampaignsDashboard = () => (
  <>
    <CampaignsPageHeader
      section={t('rm:Campaigns')}
      dashboardTitle={t('rm:CampaignsDashBoard')}
    />

    <MainTabs />

    <ImpressionShareNewsAlert />
    <RoasCalculationAlerts />

    <CampaignListFilters />

    <DashboardRetailMediaCampaigns origin="campaign" />

    <CampaignTable />
  </>
)

export default RetailMediaCampaignsDashboard
